import { ModalOverlay } from "react-aria-components";
import styled from "@emotion/styled";

export const StyledModalOverlay = styled(ModalOverlay)<{ $zIndex: number }>`
  background-color: ${({ theme }) => theme.colors.surface.overlay.default};
  z-index: ${({ $zIndex }) => $zIndex};
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const StyledFullScreenContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledModalWrapper = styled.div``;
